module.exports = {"152526100":"巴拉嘎尔高勒镇","152526101":"巴彦花镇","152526102":"吉仁高勒镇","152526103":"浩勒图高勒镇","152526104":"高日罕镇","152526200":"巴彦胡舒苏木乡","152526201":"乌兰哈拉嘎苏木","152526400":"西乌旗白音华能源化工园区","152526500":"林业总场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/152526.json
// module id = 443
// module chunks = 0